import { useAppSelector } from '../../../store/store'
import {
  HistoryWindow,
  HistoryWindowType,
  QuickTimeInterval,
  RealtimeWindow,
  RealTimeWindowType,
  TimeWindowType,
} from '../../../shared/models/time.model'
import { formatUnixMillisecondsDuration } from '../../../utils/utils'
import dayjs from 'dayjs'

const CurrentTimeWindowDisplay = () => {
  const {
    config: { timeWindow },
  } = useAppSelector((state) => state.dashboard)
  const formatLast = (timeWindowMs: number) => {
    return 'Dernières Valeurs, ' + formatUnixMillisecondsDuration(timeWindowMs)
  }
  const formatInterval = (quickInterval?: QuickTimeInterval) => {
    if (!quickInterval) return ''
    let formated = ''
    switch (quickInterval) {
      case QuickTimeInterval.YESTERDAY:
        formated += 'Hier'
        break
      case QuickTimeInterval.DAY_BEFORE_YESTERDAY:
        formated += 'Avant-hier'
        break
      case QuickTimeInterval.THIS_DAY_LAST_WEEK:
        formated += 'Ce jour, semaine dernière'
        break
      case QuickTimeInterval.PREVIOUS_WEEK:
      case QuickTimeInterval.PREVIOUS_WEEK_ISO:
        formated += 'Semaine dernière'
        break
      case QuickTimeInterval.PREVIOUS_MONTH:
        formated += 'Mois dernier'
        break
      case QuickTimeInterval.PREVIOUS_QUARTER:
        formated += 'Trimestre dernier'
        break
      case QuickTimeInterval.PREVIOUS_HALF_YEAR:
        formated += 'Semestre dernier'
        break
      case QuickTimeInterval.PREVIOUS_YEAR:
        formated += 'Année dernière'
        break
      case QuickTimeInterval.CURRENT_HOUR:
        formated += 'Heure courante'
        break
      case QuickTimeInterval.CURRENT_DAY:
      case QuickTimeInterval.CURRENT_DAY_SO_FAR:
        formated += 'Jour courant'
        break
      case QuickTimeInterval.CURRENT_WEEK:
      case QuickTimeInterval.CURRENT_WEEK_ISO:
      case QuickTimeInterval.CURRENT_WEEK_ISO_SO_FAR:
        formated += 'Semaine courante'
        break
      case QuickTimeInterval.CURRENT_MONTH:
      case QuickTimeInterval.CURRENT_MONTH_SO_FAR:
        formated += 'Mois courant'
        break
      case QuickTimeInterval.CURRENT_QUARTER:
      case QuickTimeInterval.CURRENT_QUARTER_SO_FAR:
        formated += 'Trimestre courant'
        break
      case QuickTimeInterval.CURRENT_HALF_YEAR:
      case QuickTimeInterval.CURRENT_HALF_YEAR_SO_FAR:
        formated += 'Semestre courant'
        break
      case QuickTimeInterval.CURRENT_YEAR:
      case QuickTimeInterval.CURRENT_YEAR_SO_FAR:
        formated += 'Année courante'
        break
    }
    return formated
  }
  const formatRealTime = (realTime: RealtimeWindow) => {
    switch (realTime.realtimeType) {
      case RealTimeWindowType.LAST:
        return formatLast(realTime.timeWindowsMs)
      case RealTimeWindowType.INTERVAL:
        return formatInterval(realTime.quickInterval)
      default:
        return ''
    }
  }
  const formatHistory = (history: HistoryWindow): string => {
    if (
      history.historyType === HistoryWindowType.LAST &&
      history.timeWindowsMs
    ) {
      return formatLast(history.timeWindowsMs)
    } else if (
      history.historyType === HistoryWindowType.INTERVAL &&
      history.quickInterval
    ) {
      return formatInterval(history.quickInterval)
    } else if (
      history.historyType === HistoryWindowType.FIXED &&
      history.fixedTimeWindow
    ) {
      return (
        dayjs(history.fixedTimeWindow.startTimeMs).format('DD/MM/YYYY HH:mm') +
        ' au ' +
        dayjs(history.fixedTimeWindow.endTimeMs).format('DD/MM/YYYY HH:mm')
      )
    }
    return ''
  }
  const getFormattedTimeWindow = (): string => {
    if (
      timeWindow?.timeWindowType === TimeWindowType.REAL_TIME &&
      timeWindow.realtime
    ) {
      return formatRealTime(timeWindow.realtime)
    } else if (
      timeWindow?.timeWindowType === TimeWindowType.HISTORY &&
      timeWindow.history
    ) {
      return formatHistory(timeWindow.history)
    }
    return ''
  }
  return (
    <div className="flex items-center">
      <span>{getFormattedTimeWindow()}</span>
    </div>
  )
}

export default CurrentTimeWindowDisplay
